// Sexo biológico.
//
// A pergunta é "Qual o seu sexo biológico?" e não "como você se identifica":
// o que o cálculo usa (taxa metabólica basal, % de gordura pela Navy, faixas
// de referência) é o sexo biológico, e perguntar identidade para depois
// alimentar uma fórmula biológica seria perguntar uma coisa e usar outra.
// Por isso também não há "prefiro não dizer" — sem o dado não há como
// calcular o alvo metabólico.
//
// Os `value` gravados são os de sempre ("feminino" / "masculino").

import React, { useEffect, useState } from "react";

import { Opcoes } from "../widgets/Widgets.jsx";

const OPCOES = [
  { value: "masculino", label: "Masculino" },
  { value: "feminino", label: "Feminino" },
];

const StepGender = ({ setCanProceed, setStepData }) => {
  const [genero, setGenero] = useState("");

  useEffect(() => {
    const valido = Boolean(genero);
    setCanProceed(valido);
    setStepData(valido ? { GENDER: genero } : null);
  }, [genero, setCanProceed, setStepData]);

  return (
    <Opcoes
      opcoes={OPCOES}
      valor={genero}
      onSelecionar={setGenero}
      numeradas={false}
      nome="Sexo biológico"
    />
  );
};

export default StepGender;
